module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg12.a724344b.jpg";